import React, { useEffect } from "react";
import Header from "./Header.js";
import Services from "./Services.js";
import Packages from "./Packages.js";
import ServiceCountries from "./ServiceCountries.js";
import AssociatedPartners from "./AssociatedPartners.js";
import Contact from "./Contact.js";
import About from "./About.js";
import Tour from '../Images/thailand.jpg'
import Tour1 from '../Images/Vietnam.jpg'
import Tour2 from '../Images/cambodia1.jpg'
import '../CSS/Imagesize.css'
import ChooseUs from "./ChooseUs.js";
import Footer from "./Footer.js";

function Home() {
    useEffect(() => {
        const handleScroll = () => {
            const sections = document.querySelectorAll('section');
            const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
            let currentSection = "";

            sections.forEach((section) => {
                const sectionTop = section.offsetTop - 50;
                if (window.pageYOffset >= sectionTop) {
                    currentSection = section.getAttribute('id');
                }
            });

            navLinks.forEach((link) => {
                link.classList.remove('active');
                if (link.getAttribute('href').includes(currentSection)) {
                    link.classList.add('active');
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleButtonClick = (event, id) => {
        event.preventDefault();
        document.querySelector(id).scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div>
            <Header />
            <section id="Home" className="carousel slide " data-bs-ride="carousel">
                <div className="mt-2">
                    {/* Indicators/dots */}
                    <div className="carousel-indicators">
                        <button type="button" data-bs-target="#Home" data-bs-slide-to="0" className="active"></button>
                        <button type="button" data-bs-target="#Home" data-bs-slide-to="1"></button>
                        <button type="button" data-bs-target="#Home" data-bs-slide-to="2"></button>
                    </div>

                    {/* The slideshow/carousel */}
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={Tour} alt="Los Angeles" className="d-block w-100" />
                            <div className="carousel-caption text-start">
                                <h3>Welcome to Skymy Travel,</h3>
                                <p>where unforgettable journeys begin!</p>
                                <button
                                    type="button"
                                    className="btn btn-outline-light"
                                    onClick={(e) => handleButtonClick(e, '#Services')}
                                >
                                    Service
                                </button>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={Tour1} alt="Chicago" className="d-block w-100" />
                            <div className="carousel-caption text-start">
                                <h3>Packages</h3>
                                <p>Choose from the top-rated tour packages for an unforgettable experience!</p>
                                <button
                                    type="button"
                                    className="btn btn-outline-light"
                                    onClick={(e) => handleButtonClick(e, '#Packages')}
                                >
                                    Packages
                                </button>
                            </div>
                        </div>
                        <div className="carousel-item">
                            <img src={Tour2} alt="New York" className="d-block w-100" />
                            <div className="carousel-caption text-start">
                                <h3>Places</h3>
                                <p>Travel to the world's most stunning and picturesque destinations!</p>
                                <button
                                    type="button"
                                    className="btn btn-outline-light"
                                    onClick={(e) => handleButtonClick(e, '#ServiceCountries')}
                                >
                                    Place
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Left and right controls/icons */}
                    <button className="carousel-control-prev" type="button" data-bs-target="#Home" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon"></span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#Home" data-bs-slide="next">
                        <span className="carousel-control-next-icon"></span>
                    </button>
                </div>
            </section>
            <section id="Services">
                <Services />
            </section>
            
            <ChooseUs></ChooseUs>
            
            <section id="Packages">
                <Packages />
            </section>
            <section id="ServiceCountries">
                <ServiceCountries />
            </section>
            {/* <section id="AssociatedPartners">
                <AssociatedPartners />
            </section> */}
            <section id="Contact">
                <Contact />
            </section>
            <section id="About">
                <Footer />
            </section>
        </div>
    );
}

export default Home;
